var map = {
	"./antwerp.png": "3411",
	"./black/cornell.png": "3752",
	"./black/duke.png": "a03d",
	"./black/hopkins-tall.png": "7a91",
	"./black/pennstate.png": "5ff2",
	"./cambridge.png": "a8e2",
	"./cern.png": "94ec",
	"./cornell.png": "5358",
	"./dartmouth.png": "7b5e",
	"./duke.png": "66bb",
	"./hopkins.png": "87cb",
	"./imperial.png": "195e",
	"./lanl.png": "9de4",
	"./michigan.png": "ee0f",
	"./mit.png": "7c48",
	"./oregon.png": "55d0",
	"./pennstate.png": "2544",
	"./smithsonian.png": "9d76",
	"./tamu.png": "453d",
	"./unc-chapel-hill.png": "065c",
	"./uva.png": "eab6",
	"./vassar.png": "0cc4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "69ae";